import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import * as moment from 'moment';
import {SearchService} from '../services/search.service';
import { catchError } from 'rxjs/operators'
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuditService {

  itemDisplayedColumns = []; //variable to display the tab based on the number of Categoris
  itemDataSource = []; //variable to display the items
  itemData = []; //intrem variable to store the table data for items and show it when expanding a row
  //auditCategoryURL = 'https://api.myjson.com/bins/e2al0';
  auditCategoryURL = '';
  //auditCategoryHeading = 'https://api.myjson.com/bins/a5flg';
  auditCategoryHeading = "";
  //auditEvents = 'https://api.myjson.com/bins/16yptw';
  auditEvents = '';
  //auditEventHeading = 'https://api.myjson.com/bins/pp5ac';
  auditEventHeading = '';

  constructor(private http: HttpClient, private searchService: SearchService) { }

  /*
  * function to get all the Category Item data
  * @param searchData - search details for which we need to fetch the category
  * @param categoryItems - category items details which will have the filter or sortby parameters
  * @param selectedIndex - which tab is chosed
  */
  getAuditCategory(searchData: any, categoryItems: any, selectedIndex: number) {
    this.auditCategoryURL = this.searchService.baseURL + 'applications/'+ searchData.selectedApplication +'/categories/' + searchData.selectedCategories[selectedIndex] + '/items';
    let httpParams = new HttpParams();
    let val: any;
    let orderValue: string;
    
    if (categoryItems[selectedIndex].params) {
      for (let [key, value] of Object.entries(categoryItems[selectedIndex].params)) {
        val = value;
        if (key === 'order') {orderValue = val}
        if (val && ((key === 'sortby' && orderValue) || (key !== "sortby"))) {
          httpParams = httpParams.append(key, val);        
        }
      }
    }
    return this
      .http
      .get(`${this.auditCategoryURL}`, {params: httpParams})
      .pipe(catchError(this.handleError));
  };

  /*
  * function to get all the category item's heading(s) that need to be displayed on the Category Item table (top level)
  */
  getAuditCategoryHeading(categoryname: String) {
    this.auditCategoryHeading = this.searchService.baseURL + 'applications/'+ this.searchService.searchData.selectedApplication +'/categories/' + categoryname +'/items/filters';
    return this
      .http
      .get(`${this.auditCategoryHeading}`)
      .pipe(catchError(this.handleError));
  };

  /*
  * function to get all the Audit event's heading(s) that need to be displayed on the Audit table table (secondary level that is displayed when expanding)
  */
  getAuditEventHeading() {
    this.auditEventHeading = this.searchService.baseURL + 'applications/'+ this.searchService.selectedItem.applicationCode +'/categories/' + this.searchService.selectedItem.categoryCode + '/items/'+ this.searchService.selectedItem.id + '/events/filters';
    return this
      .http
      .get(`${this.auditEventHeading}`)
      .pipe(catchError(this.handleError));
  };

  /*
  * function to Fetch all the Audit data for the selected category Item (secondary level that is displayed when expanding)
  */
  getAuditEvents() {
    let httpParams = new HttpParams();
    let val: any;
    let orderValue: string;
    this.auditEvents = this.searchService.baseURL + 'applications/'+ this.searchService.selectedItem.applicationCode +'/categories/' + this.searchService.selectedItem.categoryCode + '/items/'+ this.searchService.selectedItem.id + '/events';

    var thisItemDataSource = this.itemDataSource[this.searchService.selectedIndex].filteredData[this.searchService.selectedItemIndex];
    if (thisItemDataSource.params) {
      for (let [key, value] of Object.entries(thisItemDataSource.params)) {
        val = value;
        if (key === 'order') {orderValue = val}
        if (val && ((key === 'sortby' && orderValue) || (key !== "sortby"))) {
          httpParams = httpParams.append(key, val);        
        }
      }
    }
    return this
      .http
      .get(`${this.auditEvents}`, {params: httpParams})
      .pipe(catchError(this.handleError));
  };

  /*
  *function to catch the error
  */
  handleError(error: HttpErrorResponse){
    return throwError(error);
  }
}
